import { useState, useMemo, useCallback } from 'react';

export const useDashboard = () => {
  const filters = useMemo(
    () => [
      'Equipment-level (O&G)',
      'Facility-level (O&G)',
      'Non-O&G vs O&G comparison',
      'Benchmarking',
    ],
    [],
  );

  const subfilters = useMemo(() => ['All', 'Upstream', 'Midstream'], []);

  const timeperiods = useMemo(
    () => ['All 2024', 'Q1 2024', 'Q2 2024', 'Q3 2024', 'Q4 2024'],
    [],
  );

  const [activeFilter, setActiveFilter] = useState<string>(
    'Equipment-level (O&G)',
  );

  const handleFilterChange = useCallback((filter: string) => {
    setActiveFilter(filter);
  }, []);

  return {
    filters,
    activeFilter,
    subfilters,
    timeperiods,
    handleFilterChange,
  };
};
